import { requestQuery } from '@/services/request';
import { coreCategoriesRoute } from '@/modules/categories/domain/routes/categoryRoutes';
import { Category } from '@/types';
import { CategoryEntity } from '@/modules/categories/domain/entities/CategoryEntity';

export const getCategories = async () => {
  try {
    const response = await requestQuery<{ categories: Category[] }>({
      url: coreCategoriesRoute,
    });

    return (response?.categories || []).map((d) => new CategoryEntity(d));
  } catch (e) {
    return null;
  }
};
